import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const AutorizacionProporcionarDocumentosCrearScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario =
    "AUTORIZACIÓN PARA PROPORCIONAR DOCUMENTOS E INFORMACIÓN";
  const [formData, setFormData] = useState({
    date: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, handleSubmit } = useForm();

  const mutateFechaFG = useMutationData({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`max-w-4xl mx-auto shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative div-ignore ${isDarkMode ? "bg-gray-800 text-white" : "bg-white"}`}>
        <form
          onSubmit={handleSubmit((data) => {
            console.log(data);

            // Aseguramos que los valores seleccionados se incluyan
            const formData = {
              ...data,
            };

            // Mutación para guardar la Fecha de Detección de Riesgos
            mutateFechaFG.mutate(
              {
                data: {
                  fecha_autorizacion_proporcionar:
                    data.fecha_autorizacion_proporcionar,
                },
                tipo: "put",
              },
              {
                onSuccess: () => {
                  navigate(`/formatosG/${evaluadosList_id}`);
                  window.scrollTo(0, 0);
                },
                onError: (error) => {
                  console.error(
                    "Error al guardar Fecha de Formatos Generales:",
                    error
                  );
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          {/* Header */}
          <Header titulo={tituloFormulario} />

          {/* Contenido del formulario */}
          <div className="p-6">
            <div className="space-y-6">
              <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                <span className="mr-2">
                  Bajo protesta de decir verdad hago constar que los datos
                  proporcionados en el proceso de evaluación son verdaderos.
                </span>
              </p>

              <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                Asimismo; autorizo a los{" "}
                <Controller
                  name="fecha_autorizacion_proporcionar"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      id="fecha_autorizacion_proporcionar"
                      type="date"
                      {...field}
                      className={`border rounded-md p-2 w-40 inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                    />
                  )}
                />{" "}
                a la empresa SKA TRACKING AND SECURITY S.A. de C.V. para que
                proporcione toda la documentación e información derivada de mis
                evaluaciones.
              </p>

              <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                Se firma la presente por triplicado para los efectos legales
                conducentes
              </p>
            </div>
            <br />
            <br />
            <div className={`text-left mb-8 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              <h2 className="text-xl font-bold mb-2 flex items-left">
                {`NOMBRE: ${queryEvaluado.data?.nombre || ""} ${
                  queryEvaluado.data?.apellido_paterno || ""
                } ${queryEvaluado.data?.apellido_materno || ""}`}
              </h2>
              <h2 className="text-xl font-bold mb-2 flex items-left">
                {`PUESTO: ${queryEvaluado.data?.puesto || ""}`}
              </h2>
              <h2 className="text-xl font-bold mb-2 flex items-left">
                {`FIRMA: `}
              </h2>
            </div>
          </div>

          {/* Botones */}
          <div className="mt-4 mb-4 px-4">
            <div className="flex justify-between">
              <Button
                color="red"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(-1);
                }}
                className={`bg-red-500 hover:bg-red-600 text-white ${isDarkMode ? "bg-red-600 hover:bg-red-700" : ""}`}
              >
                Regresar
              </Button>
              <button
                type="submit"
                className={`rounded px-4 py-2 z-10 transition-colors ${isDarkMode ? "bg-green-600 hover:bg-green-700 text-white" : "bg-green-500 hover:bg-green-600 text-white"}`}
              >
                {" "}
                Guardar{" "}
              </button>
            </div>
          </div>

          {/* Footer */}
          <div className={`h-12 mt-8 flex items-center justify-center ${isDarkMode ? "bg-blue-800" : "bg-customBlue"}`}>
            <p className="text-sm text-white px-4">
              <span className="font-bold">DOCUMENTO CONFIDENCIAL</span>, prohibido
              su reproducción, copia o sacar este documento de las Instalaciones
              de Skyangel
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};
